import React, {useEffect, useState} from 'react';
import Checkbox from "../../../../../../../components/input/checkbox";


export default function BooleanInput({label, defaultValue, onChange}) {
    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        setValue(defaultValue)
    }, [defaultValue]);


    return (
        <>
            <Checkbox
                label={label}
                isReady={true}
                value={value ? 'on' : 'off'}
                onChange={ev => {
                    setValue(ev.target.checked);
                    onChange(ev.target.checked);
                }}
            />
        </>
    );
}
